module.exports = __webpack_public_path__ + "static/img/12-2.c450570.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/12-2.png
// module id = izb4
// module chunks = 15